const ADMIN_HOST = "cloudfront.haoxuexingcheng.com";
const PORTAL_HOST = "cloud.haoxuexingcheng.com";
/** 本地联调 deploy/start_local.ps1：用户门户 9001、管理端 9002 */
const LOCAL_PORTAL_PORT = "9001";
const LOCAL_ADMIN_PORT = "9002";

function currentHost() {
  if (typeof window === "undefined" || !window.location) return "";
  return (window.location.hostname || "").toLowerCase();
}

function currentPort() {
  if (typeof window === "undefined" || !window.location) return "";
  return String(window.location.port || "");
}

export function isAdminDomain() {
  if (currentHost() === ADMIN_HOST) return true;
  return currentPort() === LOCAL_ADMIN_PORT;
}

export function isPortalDomain() {
  if (currentHost() === PORTAL_HOST) return true;
  return currentPort() === LOCAL_PORTAL_PORT;
}

/** 管理端站点 Origin（门户「创建课程」等跨域跳转用） */
export function getAdminOrigin() {
  if (typeof window === "undefined" || !window.location) return "";
  const { protocol, hostname } = window.location;
  const host = (hostname || "").toLowerCase();
  if (isAdminDomain()) return window.location.origin;
  if (host === "localhost" || host === "127.0.0.1") {
    return protocol + "//" + hostname + ":" + LOCAL_ADMIN_PORT;
  }
  return protocol + "//" + ADMIN_HOST;
}

export function resolveLoginPath() {
  return isAdminDomain() ? "/admin/login" : "/index";
}

